import  gql  from 'graphql-tag'

export const contingentQuotasTdcPyme = gql`query contingentQuotasTdcPyme{ 
    contingentQuotasTdcPyme{
            edges{
                node{
                    id,
                    data
                }
            }
        }
    }`;
